export function CTAButton() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing-section');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <div className="flex flex-col items-center" data-id="element-8">
      <button onClick={scrollToPricing} className="bg-amber-500 hover:bg-amber-600 text-white font-bold py-4 px-8 rounded-lg text-xl shadow-lg transform hover:scale-105 transition-all duration-300 mb-4" data-id="element-9">
        Quiero Empezar Ahora
      </button>
      <p className="text-green-200 text-lg" data-id="element-10">
        Controla tu dinero. Evita fugas. Ahorra sin sufrir. Vive con paz.
      </p>
    </div>;
}